<template>
  <header>
    <div class="container">
      <div class="wrapper">
        <router-link to="/home" class="logo">
          <img src="../assets/images/logo.png" width="60">
        </router-link>

        <div class="links">
          <router-link to="/drafts" v-if="isAuthenticated">
            Drafts
          </router-link>
        </div>

        <router-link to="/account" v-if="isAuthenticated">
          <avatar :email="user.email" />
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import Avatar from '@/components/Avatar';

export default {
  components: {
    Avatar,
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),

    ...mapState({
      user: ({ auth }) => auth.user,
    }),
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
  header {
    background-color: $white-color;
    border-bottom: 2px solid $gray-color-light;
    height: $nav-height;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
  }

  .container {
    @include container;
    height: 100%;
  }

  .wrapper {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo {
    flex: 1;
  }

  .links {
    padding: 0 $gp * 2;

    a {
      color: $black-color;
      font-weight: $font-weight-bold;
    }
  }
</style>
